// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".spinner{position:absolute;bottom:0;left:calc(50% - 20px);border:5px solid #f3f3f3;border-top:5px solid #4a669e;border-radius:50%;width:40px;height:40px;animation:spinner 1s linear infinite}@keyframes spinner{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}", ""]);
// Exports
module.exports = exports;
